module.exports = __webpack_public_path__ + "static/media/img-unemployment@3x.b18b4675.png";